module.exports = __webpack_public_path__ + "img/B259.c57146f1.png";